import React from 'react';
import { DatabaseIcon, SlidersIcon, BarChart3Icon, ShieldCheckIcon } from 'lucide-react';
export function Features() {
  const features = [{
    icon: DatabaseIcon,
    title: 'Seamless EHR & benefits integration',
    description: 'Sync with patient profiles and covered food benefits',
    color: 'text-blue-600',
    bgColor: 'bg-blue-100'
  }, {
    icon: SlidersIcon,
    title: 'Configurable logic',
    description: 'Set nutritional thresholds or program-specific goals',
    color: 'text-green-600',
    bgColor: 'bg-green-100'
  }, {
    icon: BarChart3Icon,
    title: 'Analytics dashboard',
    description: 'Quantify engagement, savings, and health impact',
    color: 'text-orange-600',
    bgColor: 'bg-orange-100'
  }, {
    icon: ShieldCheckIcon,
    title: 'Enterprise-grade security',
    description: 'HIPAA-compliant infrastructure with SOC 2 Type II certification',
    color: 'text-emerald-600',
    bgColor: 'bg-emerald-100'
  }];
  return <section className="py-20 bg-white" data-id="element-15">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-18">
            Designed for Food as Medicine Platforms
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-19">
            Built to integrate seamlessly with your existing infrastructure
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-20">
          {features.map((feature, index) => <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 border-2 border-gray-100" data-id="element-21">
              <div className={`w-12 h-12 rounded-xl ${feature.bgColor} ${feature.color} flex items-center justify-center mb-4`} data-id="element-22">
                <feature.icon className="w-6 h-6" data-id="element-23" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-24">
                {feature.title}
              </h3>
              <p className="text-gray-600" data-id="element-25">{feature.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}